import React from "react";

import MuiBox from "@mui/material/Box";
import renderText from "../../../renderText";

function rawChildren(children: any[] = []): string {
    return children.map((child) => {
        if (child?.type === "text") return child.content;
        if (child?.children?.length) return rawChildren(child.children);
        return "";
    }).join("");
}

export const Dangerously =
    ({ c, component, html, node, context, children, ...props }: any) => {
    const content =
        html ||
        props.__html ||
        rawChildren(node?.children || []);

    delete props.__html;

    return (
        <MuiBox
            component={ c ?? component ?? 'div'}
            {...props}
            dangerouslySetInnerHTML={{ __html: renderText(`${content}`, context) }}
        />
    );
};

export default Dangerously;
